import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import axios from 'axios'

Vue.use(Vuex)

const defaultState = () => ({
    loading: false,
    activos: '',
    cuota_uno: null,
    cuotas_frances: null,
    mensaje: '',
    deudaPlanPago: [],
    deudaPlanPagoTotales: [],
    parametrosPlanPago: [],
    tiposMediosPagos: [],
    aportesActivosAfi: [],
    bancos: null,
    codigoBanco: null,
    entidadBancaria: '',
    pp_aux: '',
    idPrePlanPago: '',
    cuenta: [],
    maximosPermitidos: 0,
});

export default ({
    namespaced: true,

    state: defaultState(),

    getters: {
        cantCuotasModulosTexto(state) {
            return state.parametrosPlanPago
        },
        cantMaxCuotasModulos(state) {
            return state.maximosPermitidos.cuotas_modulos
        },
        cantMaxCuotasPesos(state) {
            return state.maximosPermitidos.cuotas_pesos
        },
        cuotaUno(state) {
            return state.cuota_uno
        },
        cuotasFrances(state) {
            return state.cuotas_frances
        },
        mensaje(state) {
            return state.mensaje
        },
        deudaPlanPago(state) {
            return state.deudaPlanPago
        },
        deudaPlanPagoTotales(state) {
            return state.deudaPlanPagoTotales
        },
        tiposMediosPagos(state) {
            return state.tiposMediosPagos
        },
        bancos(state) {
            return state.bancos
        },
        aportesActivosAfi(state) {
            return state.aportesActivosAfi
        },
        codigoBanco(state) {
            return state.codigoBanco
        },
        entidadBancaria(state) {
            return state.entidadBancaria
        },
        parametrosPlanPago(state) {
            return state.parametrosPlanPago
        },
        maxCuotasPesosTexto(state) {
            const paramPesos = state.parametrosPlanPago.find(p => p.tipo_plan === 10);
            return paramPesos ? paramPesos.cantidad_cuotas : 36;
        },
        maxCuotasModulosTexto(state) {
            const paramModulos = state.parametrosPlanPago.find(p => p.tipo_plan === 20);
            return paramModulos ? paramModulos.cantidad_cuotas : 72;
        },
        pp_aux(state) {
            return state.pp_aux
        },
        idPrePlanPago(state) {
            return state.idPrePlanPago
        },
        activos(state) {
            return state.activos
        },
        cuenta(state) {
            return state.cuenta
        },
        cargaDeudaPlanPago(state) {
            return state.deudaPlanPago.length == 0
        },
    },
    mutations: {
        RESET_STATE(state) {
            Object.assign(state, defaultState());
        },
        setLoading(state, payload) {
            state.loading = payload
        },
        setAportesActivos(state, payload) {
            state.aportesActivosAfi = payload
        },
        setMensaje(state, payload) {
            state.mensaje = payload
        },
        setDeudaPlanPago(state, payload) {
            state.deudaPlanPago = payload
        },
        setDeudaTotalesPlanPago(state, payload) {
            state.deudaPlanPagoTotales = payload
        },
        setMediosPago(state, payload) {
            state.tiposMediosPagos = payload
        },
        setBancos(state, payload) {
            state.bancos = payload
        },
        setCodigoBanco(state, payload) {
            state.codigoBanco = payload
        },
        setEntidadBancaria(state, payload) {
            state.entidadBancaria = payload
        },
        setParametrosPlanPago(state, payload) {
            state.parametrosPlanPago = payload
        },
        setPPAux(state, payload) {
            state.pp_aux = payload
        },
        setSimularPlanPago(state, payload) {
            if (payload == '') {
                state.cuota_uno = null
                state.cuotas_frances = null
            } else {
                state.cuota_uno = payload.cuota_uno.valor
                state.cuotas_frances = payload.cuotas_frances.cuota
            }
        },
        setIDPrePlanPago(state, payload) {
            state.idPrePlanPago = payload
        },
        setGuardarActivos(state, payload) {
            state.activos = payload
            //al guardar activos se guarda si es CBU: activos.dest.includes('CBU') ? 'CBU $cuenta.deb_cbu1 + $cuenta.deb_cbu2' : 'TARJ $cuenta.deb_tarjeta'
            /*             if (payload.dest.includes('CBU')) {
                            state.activos.dest = 'CBU ' + state.cuenta.deb_cbu1 + state.cuenta.deb_cbu2
                        } else {
                            state.activos.dest = 'TARJ ' + state.cuenta.deb_tarjeta
                        } */
        },
        setGuardarCuenta(state, payload) {
            state.cuenta = payload
        },
        setCantidadMax(state, payload) {
            state.maximosPermitidos = payload
        }
    },
    actions: {

        resetModulo({ commit }) {
            commit('RESET_STATE');
        },

        guardarActivos({ commit }, payload) {

            commit('setGuardarActivos', payload)
        },
        guardarCuenta({ commit }, payload) {
            commit('setGuardarCuenta', payload)
        },

        // Obtiene la deuda del plan de pago (desde router)
        async obtenerDeudaPlanPago({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/planPago/obtenerDeudaPlanPago',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: null,
            }).then(function (response) {
                const res = response.data
                commit('setMensaje', res.mensaje)
                // El caso "sin deuda financiable" se decide por los datos, no por el
                // texto del mensaje: cualquier motivo (bloqueo, deuda inexistente)
                // llega con deuda vacia y solo hay que conservar el mensaje.
                if (!res.deuda || res.deuda.length === 0) {
                    commit('setDeudaPlanPago', [])
                    commit('setDeudaTotalesPlanPago', [])
                }
                else {
                    commit('setDeudaPlanPago', res.deuda || [])
                    commit('setDeudaTotalesPlanPago', res.totales || [])
                    commit('setCantidadMax', res.simulacion || 0)
                }
            }).catch(function (error) {
                console.log(error);
                commit('setMensaje', 'Error al cargar los datos')
                commit('setDeudaPlanPago', [])
                commit('setDeudaTotalesPlanPago', [])
            }).finally(() => {
                // No llamar setSktLoader aquí, lo maneja el componente
                dispatch('auth/setSktLoader', false, { root: true })
            })
        },
        async obtenerMediosPago({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/mediosPago/obtenerMediosPago',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: { nroafi: sessionStorage.getItem('nroafi') },
            }).then(function (response) {
                const res = response.data
                commit('setMediosPago', res)
            }).catch(function (error) {
                console.log(error);
            }).finally(() => {
                // No llamar setSktLoader aquí, lo maneja el componente
            });
        },
        async obtenerParametrosPlanPago({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/planPago/obtenerParametrosPlanPago',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: { nroafi: sessionStorage.getItem('nroafi') },
            }).then(function (response) {
                const res = response.data.params
                commit('setParametrosPlanPago', res)
            }).catch(function (error) {
                console.log(error);
            }).finally(() => {
            });
        },
        async calcularCuotasPlanPago({ commit, dispatch }, payload) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/planPago/calcularCuotasPlanPago',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: payload,
            }).then(function (response) {
                const status = response.status
                if (status == 200) {
                    const res = response.data
                    if (res.cuotas_frances.mensaje.includes('valor mínimo')) {
                        dispatch('notificaciones/showSnack', {
                            message: res.cuotas_frances.mensaje,
                            type: '400',
                        }, { root: true })
                        //commit('setSimularPlanPago', res)
                        commit('setSimularPlanPago', res)
                        return
                    } else {
                        //guardo el plan de pago auxiliarmente
                        commit('setPPAux', payload)
                        commit('setSimularPlanPago', res)
                    }
                } else {
                    commit('setSimularPlanPago', '')
                }
            }).catch(function (error) {
                console.log(error);
            }).finally(() => {
            });
        },
        //nuevoPlanDePago 
        // payload: 
        /* 
        {
            "tipoPago": 1,
            "mpr_tipinteres": 1,
            "cancuotas": 4,
            "totamorti": 1535265.12,
            "totalff": 70339.35,
            "totalsf": 87924.19,
            "valmod": 2545.76,
            "totalAportes": 1377001.58,
            "numero_calculo": 18020,
            "TipoPago": 1,
            "tipo": 10,
            "anticipo": 0,
            "totalAportesModulos": 540.9,
            "gastos": 12,
            "nroafi": 19,
            "tipdebito": 1,
            "email": ""
        }
        */
        async nuevoPlanDePago({ commit, dispatch, state, rootGetters }) {
            if (rootGetters['auth/esModoGestion']) {
                dispatch('notificaciones/showSnack', {
                    message: 'Operación no permitida en modo gestión.',
                    type: '400',
                }, { root: true });
                return false;
            }
            //dispatch('auth/setSktLoader', true, { root: true })
            let shouldReload = true;
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/planPago/nuevoPlanPago',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: state.pp_aux,
            }).then(function (response) {
                if (response.status == "200") {
                    const res = response.data
                    if (res.id > 0) {
                        shouldReload = false;
                        commit('setIDPrePlanPago', res.id)
                        dispatch('procesaMediosPago')
                    }
                    else {
                        dispatch('notificaciones/showSnack', {
                            message: "Error al generar el plan de pago",
                            type: '400',
                        }, { root: true })
                    }
                }
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: error.response.data.error,
                    type: '400',
                }, { root: true })

            }).finally(async () => {
                if (shouldReload) {
                    await new Promise(resolve => setTimeout(resolve, 5000))
                    // location.reload()
                }
                //dispatch('auth/setSktLoader', false, { root: true })
            });
        },
        /* async nuevoMedioPago({ commit, dispatch }, payload) {
            await axios({ */

        blanquearSimulacionPlanPago({ commit, dispatch }) {
            commit('setPPAux', '')
            commit('setSimularPlanPago', '')
        },
        // Limpia solo lo que se llena durante el flujo del DialogoRefinanciacionPP.
        // Preserva datos cacheables: bancos, parametrosPlanPago, deudaPlanPago, tiposMediosPagos.
        limpiarFlujoPP({ commit }) {
            commit('setPPAux', '')
            commit('setSimularPlanPago', '')
            commit('setGuardarCuenta', [])
            commit('setGuardarActivos', '')
            commit('setCodigoBanco', null)
            commit('setEntidadBancaria', '')
            commit('setIDPrePlanPago', '')
            commit('setAportesActivos', [])
        },
        //guardado de archivos InputArchivos
        addFiles({ commit }, payload) {
            commit('setArchivos', payload)
        },

        async blanquearEntidad({ commit, dispatch }) {
            commit('setEntidadBancaria', '')
        },
        async getBancos({ commit, dispatch }) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/mediosPago/leeBancos',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(function (response) {
                const res = response.data.bancos
                commit('setBancos', res)
            }).catch(function (error) {
                console.log(error);
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })
            });
        },
        async aportesActivos({ commit, dispatch }, payload) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/mediosPago/aportesActivos',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: payload
            }).then(function (response) {
                const res = response.data
                commit('setAportesActivos', res.body)
            }).catch(function (error) {
                console.log(error);
            }).finally(() => {
                dispatch('auth/setSktLoader', false, { root: true })
            });
        },


        async procesaMediosPago({ commit, dispatch, rootState, state, rootGetters }) {
            if (rootGetters['auth/esModoGestion']) {
                dispatch('notificaciones/showSnack', {
                    message: 'Operación no permitida en modo gestión.',
                    type: '400',
                }, { root: true });
                return false;
            }
            dispatch('auth/setSktLoader', true, { root: true })
            // Compruebo si existe archivo para enviar
            const comprobante = rootState.dataUser?.comprobante || [];

            // Determinar si la cuenta tiene CBU o tarjeta
            const esCBU = Boolean(state.cuenta?.deb_cbu1 && state.cuenta?.deb_cbu2);
            const esTarjeta = Boolean(state.cuenta?.deb_tarjeta);
            const tieneArchivo = comprobante.length > 0
            const destino = esCBU ? `CBU ${state.cuenta.deb_cbu1}${state.cuenta.deb_cbu2}` : esTarjeta ? `TARJ ${state.cuenta.deb_tarjeta}` : '';
            const activosPayload = {
                abr: "PX",
                dest: destino,
                nro: state.idPrePlanPago,
                banco: state.cuenta.bco_nombre || ''
            };

            const headers = {
                "Content-Type": "application/json",
            }
            let payload;

            if (state.cuenta?.esNueva && tieneArchivo) {
                const formData = new FormData();
                formData.append('activos', JSON.stringify([activosPayload]));
                formData.append('comprobante', comprobante[0]);
                formData.append(esCBU ? 'cbu' : 'tarj', JSON.stringify([state.cuenta]));
                headers["Content-Type"] = "multipart/form-data";
                payload = formData;
            } else {
                payload = { activos: [activosPayload] };
            }
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/mediosPago/procesaMediosPago',
                withCredentials: false,
                headers: headers,
                data: payload
            }).then(function (response) {
                if (response.status == 200) {
                    const res = response.data
                    console.log(res.mensaje)
                    /*                 
                        if (res.codigo > 0) {
                            dispatch('notificaciones/showSnack', {
                                message: res.mensaje,
                                type: '200',
                                }, { root: true })
                        }
                    */
                } else {
                    dispatch('notificaciones/showSnack', {
                        message: "Error al guardar el medio de pago",
                        type: '400',
                    }, { root: true })
                }
            }).catch(function (error) {
                console.log(error);
                dispatch('notificaciones/showSnack', {
                    message: "Error al guardar el medio de pago",
                    type: '400',
                }, { root: true })
            }).finally(() => {
                dispatch('tramites/getTramites', null, { root: true })
                dispatch('auth/setSktLoader', false, { root: true })
                dispatch('blanquearSimulacionPlanPago')
                router.push({ path: '/tramites', query: { fromPlanPago: '1' } }).catch((() => { }))
            });
        },
        /*
        response: 
        {"success": 1, "msg":"CBU valido", "cod":17,"nombre":"BBVA BANCO FRANC\u00c9S S.A."}
        
        payload: { cbu }
        */
        async validarCBU({ commit, dispatch }, payload) {
            try {
                const response = await axios({
                    method: 'post',
                    //url: process.env.VUE_APP_MERCADOPAGO_API + 'validar/cbu',
                    url: process.env.VUE_APP_API + 'portal/mediosPago/validarCBU',
                    withCredentials: false,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    data: payload
                })
                const res = response.data
                if (res.success) {
                    commit('setCodigoBanco', res.cod)
                    commit('setEntidadBancaria', res.nombre)
                    dispatch('notificaciones/showSnack', {
                        message: "Cuenta aprobada para tramitar",
                        type: '200',
                    }, { root: true })
                    return true
                } else {
                    commit('setEntidadBancaria', '')
                    dispatch('notificaciones/showSnack', {
                        message: "Entidad bancaria no encontrada",
                        type: '400',
                    }, { root: true })
                    return false
                }
            } catch (error) {
                return false
            }
        },
        async validarTarjeta({ state, commit, dispatch }, payload) {
            try {
                const response = await axios({
                    method: 'post',
                    url: process.env.VUE_APP_MERCADOPAGO_API + 'validar/tarjeta',
                    withCredentials: false,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    data: JSON.stringify(payload)
                });

                const status = response.status;
                const res = response.data;

                if (status == 200) {
                    commit('setCodigoBanco', res.tarjeta.deb_banco);
                    const entidadBancaria = state.bancos.find(banco => banco.id == res.tarjeta.deb_banco);
                    commit('setEntidadBancaria', entidadBancaria ? entidadBancaria.nombre : '');

                    // Retornar el resultado con el banco_id
                    return {
                        valida: true,
                        banco_id: res.tarjeta.deb_banco,
                        banco_nombre: entidadBancaria ? entidadBancaria.nombre : ''
                    };
                } else {
                    dispatch('notificaciones/showSnack', {
                        message: res.message || "Tarjeta no válida",
                        type: '400',
                    }, { root: true });
                    return { valida: false };
                }
            } catch (error) {
                console.log(error);
                dispatch('notificaciones/showSnack', {
                    message: error.response?.data?.message || "Error al validar la tarjeta",
                    type: '400',
                }, { root: true });
                return { valida: false };
            }
        }
    }
});